import { Component, OnInit } from '@angular/core';
import { PingService } from './Shared/Services/ping.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
    title = 'sii';
    backend: boolean;
    recaptcha: boolean;
    loading: boolean = true;
    themeKey = 'THEME';
    colorThemeKey = 'THEME-COLOR';
    constructor(private pingService: PingService) {}
    async ngOnInit(): Promise<void> {
        const darkClassName = 'darkMode';
        const darkDevClassName = 'darkMode-dev';
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';
        const classNames = [
            darkClassName,
            darkDevClassName,
            lightClassName,
            lightblueClassName,
            lightRedClassName,
        ];

        const classTheme = localStorage.getItem(this.themeKey);
        const classColorTheme = localStorage.getItem(this.colorThemeKey);

        if (
            classNames.includes(classTheme) ||
            classNames.includes(classColorTheme)
        ) {
            localStorage.clear();
            sessionStorage.clear();
        }

        this.backend = await this.pingService.makePing();
        if (!environment.check) {
            const token: string | undefined =
                await this.pingService.recaptchaV3('pingAction');
            this.recaptcha = token
                ? await this.pingService.validateRecapchaV3(token)
                : true;
        }

        this.loading = false;
    }

    async onNoRobot(event) {
        this.pingService.token_captcha2 = event;
        this.recaptcha = true;

        const token_captcha2 = this.pingService.token_captcha2;

        if (token_captcha2) {
            const valid2 = await this.pingService.validateRecapchaV2(
                token_captcha2
            );

            localStorage.removeItem('TOKEN_R2');

            this.pingService.force_recapcha = !valid2;
        } else {
            this.pingService.force_recapcha = true;
        }

        location.reload();
    }
}
